import * as React from 'react';
import  { withStyles, WithStyles, StyleRules} from '@mui/styles';
import { Theme } from '@mui/styles';
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material';
import {Checkbox} from '@mui/material';
import {Tooltip} from '@mui/material';

const styles = (theme:Theme):StyleRules => ({
  container: {
    width: "100%" 
  }
})

interface Props extends React.HTMLProps<HTMLDivElement>{
    numSelected: number;
    onRequestSort: Function;
    onSelectAllClick: (event: any, checked: boolean) => void;
    order: "desc" | "asc" | undefined;
    orderBy: string;
    rowCount: number;
    columns: Array<any>;
    includeSelectionColumn?: boolean
    includeActionColumn?: boolean
    
};

type State = {
};

class SelectableTableHeader extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props:Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {}; 
  }

  createSortHandler = (property:string) => (event:any) => {
    this.props.onRequestSort(event, property);
  };

  UNSAFE_componentWillReceiveProps(newProps:Props & WithStyles<keyof typeof styles>){

  }


  render () {


      const { columns, onSelectAllClick, order, orderBy, numSelected, rowCount, includeActionColumn, includeSelectionColumn } = this.props;

    return (
      <TableHead>
        <TableRow>
          { includeSelectionColumn && 
            <TableCell padding="checkbox">
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={numSelected === rowCount}
                onChange={onSelectAllClick}
              />
            </TableCell>
          }
          {columns.map(column => {
            return (
              <TableCell
                key={column.id}
                align={ column.numeric ? 'right' : 'left'}
                padding={column.disablePadding ? 'none' : 'normal'}
              >
                <Tooltip
                  title="Sort"
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
          { includeActionColumn && 
          <TableCell padding="none">
          </TableCell>
          }
        </TableRow>
      </TableHead>
    );
  }
}

export default withStyles(styles)(SelectableTableHeader);
